import React from 'react'

const FormInput = (props) => {
    // Component-only props — must NOT be spread onto the native <input>.
    const {
        idValue,
        type,
        isInvalid,
        isDisabled,
        inputClassName,
        className,
        iconLeft,
        iconRight,
        noFocusRing,
        errorMsg,
        label,
        showLabel,
        showOptionalLabel,
        required,
        ...rest
    } = props;

    const ringClasses = noFocusRing
        ? 'ring-0 shadow-none outline-none focus:ring-0 focus:outline-none focus-visible:ring-0 focus-visible:outline-none'
        : 'shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-secondary';
    const inputClasses = `peer order-2 block w-full rounded-md border-0 py-2 text-gray-900 placeholder:text-gray-400 disabled:ring-gray-200 disabled:bg-gray-100 disabled:text-gray-500 disabled:cursor-not-allowed ${ringClasses} ${isInvalid ? 'ring-red-500' : ''}`;
    const combinedInputClasses = [inputClasses, inputClassName, className].filter(Boolean).join(' ');

    return (
        <div className='relative flex flex-col'>
            <input
                {...rest}
                className={combinedInputClasses}
                type={type === 'input' ? 'text' : type}
                id={idValue}
                disabled={isDisabled}
                required={required}
                aria-invalid={isInvalid}
            />
            {iconLeft ? (
                <div className='absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none'>
                    {iconLeft}
                </div>
            ) : null}
            {iconRight ? (
                <div className='absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none'>
                    {iconRight}
                </div>
            ) : null}
            {errorMsg ? (
                <p className='mt-2 order-3 invisible peer-placeholder-shown:!invisible peer-placeholder-shown:!h-px peer-invalid:visible peer-invalid:h-4 h-px text-red text-sm transition-all'>
                    {errorMsg}
                </p>
            ) : null}

            {label ? (
                <label
                    htmlFor={idValue}
                    className={
                        showLabel
                            ? 'p order-1 block mb-2 text-sm font-medium leading-6 text-gray-900 peer-invalid:text-red'
                            : 'sr-only'
                    }
                >
                    {label} {required ? <span className="text-red-500">*</span> : showOptionalLabel !== false && <span className="text-gray-500 text-xs ml-3"> (optional)</span>}
                </label>
            ) : null}
        </div>
    )
}

export default FormInput
